import { ExternalLink } from "lucide-react";
import { CLIENTS, SECTOR_TAGS } from "@/lib/clients";
import { Reveal } from "@/components/motion";

const CLIENT_SECTOR = {
  "Barbara Positano Luxury Boat Tours": "Luxury boat tour",
  "Ristruttura Plus": "Ristrutturazioni",
  "Gusto Verace": "Ristorazione",
  "Breathe Yoga Studios": "Yoga & Pilates",
};

const CARDS = [
  ...CLIENTS.map((c) => ({ sector: CLIENT_SECTOR[c.name], name: c.name.replace(" Luxury Boat Tours", ""), url: c.url, place: c.sector.split(" · ")[1] })),
  ...SECTOR_TAGS.filter((t) => !Object.values(CLIENT_SECTOR).includes(t)).map((t) => ({ sector: t })),
];

const Card = ({ c, i }) => {
  const Tag = c.url ? "a" : "div";
  const props = c.url ? { href: c.url, target: "_blank", rel: "noopener noreferrer" } : {};
  return (
    <Reveal delay={Math.min(i * 0.06, 0.5)} className="snap-start shrink-0">
      <Tag
        {...props}
        className={`lift group flex flex-col justify-between w-[200px] sm:w-[220px] h-[260px] p-6 border ${
          c.name ? "border-[#FACC15]/40 bg-[#0c0c0c]" : "border-[#1f1f1f] bg-[#080808]"
        }`}
        data-testid={c.name ? "client-card" : "sector-card"}
      >
        <div>
          <p className="text-[10px] tracking-[0.22em] uppercase text-white/40">{c.name ? "Cliente" : "Settore"}</p>
          <h3
            className={`mt-4 font-bold leading-[1.05] ${c.name ? "text-[#FACC15]" : "text-white/85"} text-2xl`}
            style={{ fontFamily: "'Outfit', sans-serif", letterSpacing: "-0.02em" }}
          >
            {c.sector}
          </h3>
        </div>
        {c.name ? (
          <div className="flex items-end justify-between gap-2">
            <div>
              <p className="text-white text-sm font-semibold leading-tight">{c.name}</p>
              {c.place && <p className="text-white/45 text-xs mt-1">{c.place}</p>}
            </div>
            {c.url && <ExternalLink size={15} className="text-white/40 group-hover:text-[#FACC15] transition-colors shrink-0" />}
          </div>
        ) : (
          <p className="text-white/40 text-xs leading-relaxed">Metodo integrato applicato al settore.</p>
        )}
      </Tag>
    </Reveal>
  );
};

export const SectorsSection = ({
  eyebrow = "Settori e clienti",
  title = <>Chi ci ha scelto <span className="text-[#FACC15]">come partner</span></>,
  intro = "Dalla ristorazione alla nautica, dal benessere all'edilizia: lavoriamo con imprenditori di settori molto diversi tra loro, portando ogni volta lo stesso metodo integrato.",
}) => (
  <section className="py-16 sm:py-32 overflow-hidden" data-testid="sectors-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <Reveal>
        <p className="eyebrow mb-5">{eyebrow}</p>
        <h2
          className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white max-w-3xl leading-[1.1]"
          style={{ fontFamily: "'Outfit', sans-serif", letterSpacing: "-0.025em" }}
          data-testid="sectors-h2"
        >
          {title}
        </h2>
        <p className="mt-6 text-white/70 text-base sm:text-lg max-w-3xl leading-relaxed">{intro}</p>
      </Reveal>
    </div>

    <div className="mt-14 pl-6 lg:pl-[max(2rem,calc((100vw-80rem)/2+2rem))]">
      <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-4 pr-6 no-scrollbar" data-testid="clients-grid">
        {CARDS.map((c, i) => <Card key={c.sector} c={c} i={i} />)}
      </div>
    </div>
  </section>
);

export default SectorsSection;
